import { useState } from 'react'
import styled from 'styled-components'
import Button from '@mui/material/Button'
import Modal from '@mui/material/Modal'
import useMediaQuery from '@mui/material/useMediaQuery'
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop'
import AddIcon from '@mui/icons-material/Add'
import CloseIcon from '@mui/icons-material/Close'
import TaskOutlinedIcon from '@mui/icons-material/TaskOutlined'
import { Box } from '@mui/material'

import CustomView from '../CustomView'
import CustomFilterModal from '../CustomFilterModal'
import CustomGraphy from '../CustomGraphy'
// import { useAssetLocation } from '@/hooks/useAssetLocation'

const styleModal = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 'calc(100% - 32px)',
  maxWidth: '500px',

  borderRadius: '8px',
  border: '1.5px solid #C4C4C4',
  boxShadow: 24,
  p: 4,
  maxHeight: 'calc(100vh - 32px)',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column'
}

const SCustomButton = styled(Button)`
  && {
    height: 44px;
    text-transform: capitalize;
    font-size: 14px;
    color: #c4c4c4;
    border: 1.5px solid #c4c4c4;
    margin: 5px;

    &.acitve {
      color: #2e363e;
      border-color: #2e363e;
    }
  }
`

const CustomCounter = styled(Box)`
  && {
    padding: 2px 8px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.2);
    color: #fff;
    font-size: 12px !important;
    font-weight: 500;
  }
`

function TableTools({
  createNewData,
  buttonText,
  formFilter,
  handleUpdatePatio,
  actionCancel,
  handleExport,
  handleReprove,
  handleApprove,
  handleActivate,
  handleInactivate,
  handleBatchOfReport,
  handleCleanFilters,
  handleManagerAnalysis,
  handleIntegration,
  handleMargin,
  hasFilters,
  columns,
  setColumns,
  columnsId,
  setColumnsId,
  selectedRows,
  hideColumnManager,
  customTableTools,
  pendingManagerReviewSelected = 0,
  handlePermissions
}: any) {
  enum ButtonText {
    Breakdown = 'breakdown',
    Category = 'category',
    CategoriaVistoria = 'categoriaVistoria',
    Product = 'product',
    Providers = 'providers',
    Services = 'services',
    SerialItems = 'serialItems',
    Accessories = 'accessories',
    Mark = 'marks',
    SLA = 'SLA',
    Inspection = 'inspection',
    Refund = 'refund',
    Company = 'company',
    Precification = 'precification',
    Users = 'users',
    Profile = 'profile',
    Preparation = 'preparation',
    ProductPreparation = 'product-preparation',
    BreakdownPreparation = 'breakdown-preparation',
    ServicesPreparation = 'services-preparation',
    EvaluationType = 'evaluationType',
    InspectionPhoto = 'inspectionPhoto',
    PhotoSection = 'photoSection',
    PhotoFlow = 'photoFlow',
    Checklist = 'checklist'
  }

  const mobile = useMediaQuery('(max-width:991px)')
  const [open, setOpen] = useState(false)
  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)
  const [columnsView, setColumnsView] = useState(columns)

  // const { CAN_VIEW_INTEGRACOES } = useAssetLocation()

  function ColumnsBehaviour(column: string, key: number) {
    const arrayTemp = [...columnsView]
    const arrayTempId = [...columnsId]

    if (arrayTemp.includes(column)) {
      arrayTemp[key] = null
      arrayTempId.splice(arrayTempId.indexOf(key), 1)
    } else {
      arrayTemp[key] = column
      arrayTempId.push(key)
    }

    return {
      arrayTemp: arrayTemp,
      arrayTempId: arrayTempId
    }
  }

  function handleColumns(column: string, key: number) {
    const returnBehaviour = ColumnsBehaviour(column, key)
    setColumnsView(returnBehaviour.arrayTemp)
    setColumns(returnBehaviour.arrayTemp)
    setColumnsId(returnBehaviour.arrayTempId)
  }

  // insert your new data component here
  function getButtonText() {
    switch (buttonText) {
      case ButtonText.Breakdown:
      case ButtonText.BreakdownPreparation:
        return 'Nova avaria'
      case ButtonText.Category:
        return 'Nova categoria'
      case ButtonText.CategoriaVistoria:
        return 'Nova categoria da vistoria'
      case ButtonText.Product:
      case ButtonText.ProductPreparation:
        return 'Novo produto'
      case ButtonText.Providers:
        return 'Novo prestador'
      case ButtonText.Services:
      case ButtonText.ServicesPreparation:
        return 'Novo serviço'
      case ButtonText.SLA:
        return 'Novo sla'
      case ButtonText.SerialItems:
        return 'Novo item de série'
      case ButtonText.Accessories:
        return 'Novo acessório'
      case ButtonText.Mark:
        return 'Nova marca'
      case ButtonText.Inspection:
        return 'Nova vistoria'
      case ButtonText.Company:
        return 'Nova Empresa'
      case ButtonText.Refund:
        return 'Cadastrar reembolso'
      case ButtonText.Precification:
        return 'Nova Precificação'
      case ButtonText.Users:
        return 'Novo Usuário'
      case ButtonText.Preparation:
        return 'Nova Preparação'
      case ButtonText.Profile:
        return 'Novo Perfil'
      case ButtonText.EvaluationType:
        return 'Novo Tipo'
      case ButtonText.InspectionPhoto:
        return 'Nova Foto'
      case ButtonText.PhotoSection:
        return 'Nova Seção'
      case ButtonText.PhotoFlow:
        return 'Novo Fluxo'
      case ButtonText.Checklist:
        return 'Nova Checklist'
      default:
        return ''
    }
  }

  return (
    <CustomView
      backColor="white"
      px={3}
      pt={4}
      flexDirection={{ xs: 'column', md: 'row' }}
      justifyContent="space-between"
      gap={2}
    >
      <CustomView flexDirection="column" gap={2} flex={1}>
        <CustomView flexDirection={{ xs: 'column', md: 'row' }} gap={2}>
          <CustomView
            flexDirection={{ xs: 'column', md: 'row' }}
            flexWrap={'wrap'}
            gap={2}
          >
            {handleUpdatePatio && (
              <Button
                onClick={handleUpdatePatio}
                variant="outlined"
                style={{
                  height: '44px',
                  textTransform: 'capitalize',
                  fontSize: '14px',
                  color: '#2E363E',
                  border: '1.5px solid #C4C4C4',
                  width: 'auto'
                }}
              >
                Atualizar localização
              </Button>
            )}

            {handleIntegration && handlePermissions?.canExecuteIntegration && (
              <Button
                onClick={handleIntegration}
                variant="outlined"
                style={{
                  height: '44px',
                  textTransform: 'capitalize',
                  fontSize: '14px',
                  color: '#2E363E',
                  border: '1.5px solid #C4C4C4',
                  width: 'auto'
                }}
              >
                Processar Integrações
              </Button>
            )}

            {handleBatchOfReport && (
              <Button
                variant="outlined"
                style={{
                  height: '44px',
                  textTransform: 'initial',
                  fontSize: '14px',
                  color: '#2E363E',
                  border: '1.5px solid #C4C4C4'
                }}
                onClick={handleBatchOfReport}
              >
                Gerar lote de laudo
              </Button>
            )}

            {handleApprove && (
              <Button
                onClick={handleApprove}
                variant="outlined"
                style={{
                  height: '44px',
                  textTransform: 'capitalize',
                  fontSize: '14px',
                  color: '#2E363E',
                  border: '1.5px solid #C4C4C4'
                }}
              >
                Aprovar
              </Button>
            )}
            {handleReprove && (
              <Button
                onClick={handleApprove}
                variant="outlined"
                style={{
                  height: '44px',
                  textTransform: 'capitalize',
                  fontSize: '14px',
                  color: '#2E363E',
                  border: '1.5px solid #C4C4C4'
                }}
              >
                Reprovar
              </Button>
            )}
            {handleActivate && (
              <Button
                onClick={handleActivate}
                variant="outlined"
                style={{
                  height: '44px',
                  textTransform: 'capitalize',
                  fontSize: '14px',
                  color: '#2E363E',
                  border: '1.5px solid #C4C4C4'
                }}
              >
                Ativar
              </Button>
            )}

            {handleInactivate && (
              <Button
                onClick={handleInactivate}
                variant="outlined"
                style={{
                  height: '44px',
                  textTransform: 'capitalize',
                  fontSize: '14px',
                  color: '#2E363E',
                  border: '1.5px solid #C4C4C4'
                }}
              >
                Inativar
              </Button>
            )}

            {actionCancel && (
              <Button
                variant="outlined"
                style={{
                  height: '44px',
                  textTransform: 'capitalize',
                  fontSize: '14px',
                  color: '#2E363E',
                  border: '1.5px solid #C4C4C4'
                }}
                onClick={() => actionCancel()}
              >
                Cancelar
              </Button>
            )}

            {handleExport && (
              <Button
                onClick={handleExport}
                startIcon={<LocalPrintshopIcon />}
                variant="outlined"
                style={{
                  height: '44px',
                  textTransform: 'capitalize',
                  fontSize: '14px',
                  color: '#2E363E',
                  border: '1.5px solid #C4C4C4'
                }}
              >
                Exportar
              </Button>
            )}

            {handleManagerAnalysis && (
              <Button
                onClick={handleManagerAnalysis}
                startIcon={<TaskOutlinedIcon />}
                variant="contained"
                style={{
                  height: '44px',
                  textTransform: 'initial',
                  fontSize: '14px',
                  boxShadow: 'none',
                  outline: 'none',
                  backgroundColor: !pendingManagerReviewSelected
                    ? '#f3f4f6'
                    : '#142954',
                  color: !pendingManagerReviewSelected ? '#b4bac9' : '#FFFFFF',
                  border: `1.5px solid ${
                    !pendingManagerReviewSelected ? '#d4dae7' : '#142954'
                  }`,
                  fontWeight: 300
                }}
                disabled={!pendingManagerReviewSelected}
                {...(pendingManagerReviewSelected > 0 && {
                  endIcon: (
                    <CustomCounter>
                      {pendingManagerReviewSelected}
                    </CustomCounter>
                  )
                })}
              >
                Analise do Gestor
              </Button>
            )}

            {!hideColumnManager && (
              <Button
                onClick={handleOpen}
                variant="outlined"
                style={{
                  height: '44px',
                  textTransform: 'capitalize',
                  fontSize: '14px',
                  color: '#2E363E',
                  border: '1.5px solid #C4C4C4'
                }}
              >
                Colunas
              </Button>
            )}

            {formFilter && <CustomFilterModal>{formFilter}</CustomFilterModal>}

            {handleCleanFilters && (
              <Button
                disabled={!hasFilters}
                onClick={handleCleanFilters}
                style={{
                  height: '44px',
                  textTransform: 'capitalize',
                  fontSize: '14px',
                  color: !hasFilters ? 'rgba(0, 0, 0, 0.26)' : '#2E363E'
                }}
              >
                Limpar Filtros
              </Button>
            )}
          </CustomView>

          {customTableTools && customTableTools}
        </CustomView>
      </CustomView>

      {buttonText && (
        <CustomView display="contents">
          <Button
            onClick={createNewData}
            startIcon={
              <AddIcon
                style={{ borderRadius: '4px', border: '1px solid #C4C4C4' }}
              />
            }
            variant="outlined"
            style={{
              height: '44px',
              textTransform: 'capitalize',
              fontSize: '14px',
              color: '#2E363E',
              border: '1.5px solid #C4C4C4'
            }}
          >
            {getButtonText()}
          </Button>
          {handleMargin && (
            <Button
              onClick={handleMargin}
              disabled={!selectedRows || selectedRows.length === 0}
              startIcon={
                <AddIcon
                  style={{ borderRadius: '4px', border: '1px solid #C4C4C4' }}
                />
              }
              variant="outlined"
              style={{
                height: '44px',
                textTransform: 'capitalize',
                fontSize: '14px',
                color: '#2E363E',
                border: '1.5px solid #C4C4C4'
              }}
            >
              Adicionar Margem em Lote
            </Button>
          )}
        </CustomView>
      )}

      <Modal keepMounted open={open} onClose={handleClose}>
        <CustomView
          backColor="white"
          sx={styleModal}
          style={{ minWidth: mobile ? '100%' : '400px' }}
        >
          <>
            <CustomView
              flexDirection="row"
              justifyContent="space-between"
              style={{ borderBottom: '1px solid #f8f8f8', padding: '5px' }}
            >
              <CustomGraphy fontSize={20}>Colunas</CustomGraphy>
              <CustomView
                onClick={handleClose}
                style={{ cursor: 'pointer', color: '#2C2C2C' }}
                width="unset"
              >
                <CloseIcon fontSize="large" />
              </CustomView>
            </CustomView>
            <CustomView
              mt="20px"
              flexDirection="row"
              display="inline-block"
              justifyContent="space-between"
              sx={{
                overflowY: 'auto',
                paddingRight: '4px'
              }}
            >
              {columns.map((item: string, index: number) => (
                <SCustomButton
                  key={index}
                  onClick={() => handleColumns(item, index)}
                  className={columnsView.includes(item) && 'acitve'}
                >
                  {item}
                </SCustomButton>
              ))}
            </CustomView>
          </>
        </CustomView>
      </Modal>
    </CustomView>
  )
}

export default TableTools
